<div class="leadership-container variant-premium">
  <app-asset-header [config]="headerConfig"></app-asset-header>
  
  <div class="leadership-content">
    <!-- Main Layout -->
    <div class="leadership-main">
      <div class="leadership-container-inner">
        <!-- Vertical Sidebar (25%) -->
        <aside class="leadership-sidebar">
          <div class="leadership-sidebar-card">
            <div class="leadership-sidebar-header">
              <h2 class="leadership-sidebar-title">Categories</h2>
            </div>

            <div class="leadership-sidebar-menu">
              <button 
                *ngFor="let tab of categoryTabs"
                [class.active]="activeCategory === tab.key"
                (click)="changeCategory(tab.key)"
                class="leadership-sidebar-menu-item"
                type="button">
                <span class="menu-label">{{ tab.label }}</span>
              </button>
            </div>
          </div>
        </aside>

        <!-- Main Content Area (75%) -->
        <main class="leadership-grid">
          <!-- Category content -->
          <app-leadership-provider 
            *ngIf="activeCategory === 'providers'"
            [leadershipMembers]="leadershipMembers"
            [selectedDesign]="selectedDesign"
            [providersPagination]="providersPagination"
            (loadMore)="loadMoreProviders()">
          </app-leadership-provider>
          <app-leadership-assets 
            *ngIf="activeCategory === 'assets'"
            [leadershipMembers]="leadershipMembers"
            [selectedDesign]="selectedDesign"
            [assetsPagination]="assetsPagination"
            (loadMore)="loadMoreAssets()">
          </app-leadership-assets>
          <app-leadership-organisation 
            *ngIf="activeCategory === 'organisation'"
            [leadershipMembers]="leadershipMembers"
            [selectedDesign]="selectedDesign"
            [organisationPagination]="organisationPagination"
            (loadMore)="loadMoreOrganisations()">
          </app-leadership-organisation>

    <!-- Provider-specific designs (only show for providers) - Moved to ProviderComponent -->
    <ng-container *ngIf="activeCategory === 'providers' && false">
      <!-- Grid Design -->
      <ng-container *ngIf="selectedDesign === 'grid'">
      <div class="grid-design">
        <div class="grid-leadership">
          <div class="grid-card" *ngFor="let member of leadershipMembers" [class.top-rank]="member.rank <= 3">
            <div class="grid-rank-badge" *ngIf="member.rank <= 3">{{ member.rank }}</div>
            <div class="grid-avatar">
              <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="grid-content">
              <h3 class="grid-name">{{ member.name }}</h3>
              <p class="grid-title">{{ member.title }}</p>
              <p class="grid-role">{{ member.role }}</p>
              <p class="grid-bio">{{ member.bio }}</p>
              <div class="grid-expertise" *ngIf="member.expertise && member.expertise.length > 0">
                <span class="grid-tag" *ngFor="let skill of member.expertise.slice(0, 3)">{{ skill }}</span>
              </div>
              <div class="grid-score" *ngIf="member.score">Score: {{ member.score }}</div>
            </div>
            <div class="grid-actions">
              <a *ngIf="member.email" [href]="'mailto:' + member.email" class="grid-link" title="Email">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" stroke-width="2"/>
                  <polyline points="22,6 12,13 2,6" stroke="currentColor" stroke-width="2"/>
                </svg>
              </a>
              <a *ngIf="member.linkedin" [href]="member.linkedin" target="_blank" rel="noopener noreferrer" class="grid-link" title="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" stroke="currentColor" stroke-width="2"/>
                  <rect x="2" y="9" width="4" height="12" stroke="currentColor" stroke-width="2"/>
                  <circle cx="4" cy="4" r="2" stroke="currentColor" stroke-width="2"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Timeline Design -->
    <ng-container *ngIf="selectedDesign === 'timeline'">
      <div class="timeline-design">
        <div class="timeline-container">
          <div class="timeline-item" *ngFor="let member of leadershipMembers; let i = index">
            <div class="timeline-marker" [class.top-three]="member.rank <= 3">
              <span class="timeline-rank">{{ member.rank }}</span>
            </div>
            <div class="timeline-content">
              <div class="timeline-card">
                <div class="timeline-header">
                  <div class="timeline-avatar">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div class="timeline-info">
                    <h3 class="timeline-name">{{ member.name }}</h3>
                    <p class="timeline-role">{{ member.role }}</p>
                    <p class="timeline-title">{{ member.title }}</p>
                  </div>
                  <div class="timeline-score" *ngIf="member.score">{{ member.score }}</div>
                </div>
                <p class="timeline-bio">{{ member.bio }}</p>
                <div class="timeline-expertise" *ngIf="member.expertise && member.expertise.length > 0">
                  <span class="timeline-tag" *ngFor="let skill of member.expertise">{{ skill }}</span>
                </div>
                <div class="timeline-actions">
                  <a *ngIf="member.email" [href]="'mailto:' + member.email" class="timeline-link">Email</a>
                  <a *ngIf="member.linkedin" [href]="member.linkedin" target="_blank" rel="noopener noreferrer" class="timeline-link">LinkedIn</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Magazine Design -->
    <ng-container *ngIf="selectedDesign === 'magazine'">
      <fieldset class="leadership-provider-fieldset" *ngIf="activeCategory === 'providers'">
        <legend class="leadership-provider-fieldset--legend">Provider Leaderboard</legend>
        
        <div class="magazine-design">
        <!-- Featured Leader (Position 1 only) -->
        <div class="magazine-featured animate-fade-in" *ngIf="topThree[0]">
          <span class="featured-badge-top">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
            </svg>
            #1 TOP LEADER
          </span>
          <div class="featured-content">
            
            <div class="featured-info">
              <div class="featured-name-row">
                <div class="featured-name-left">
                  <div class="featured-name-text">
                    <div class="featured-name-row-inline">
                      <h2 class="featured-name">{{ topThree[0].name }}</h2>
                      <div class="featured-crown">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                          <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" fill="#FFD700" stroke="#FFA500" stroke-width="1.5"/>
                          <circle cx="12" cy="12" r="2" fill="#FFA500"/>
                        </svg>
                      </div>
                    </div>
                    <p class="featured-role">{{ topThree[0].role }}</p>
                  </div>
                </div>
                <div class="featured-scores" *ngIf="topThree[0].score">
                  <div class="featured-score featured-score--inline">
                    <span class="score-label">Published</span>
                    <span class="score-metric">
                      <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <path d="M7 10l5-5 5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="score-value">{{ topThree[0].score }}</span>
                    </span>
                  </div>
                  <div class="featured-score featured-score--inline">
                    <span class="score-label">Upvotes</span>
                    <span class="score-metric">
                      <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11a2 2 0 0 0 2-2l1-7a2 2 0 0 0-2-2h-5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                        <path d="M7 22H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                      <span class="score-value">{{ topThree[0].score }}</span>
                    </span>
                  </div>
                  <div class="featured-score featured-score--inline">
                    <span class="score-label">Downloads</span>
                    <span class="score-metric">
                      <svg class="score-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                      <span class="score-value">{{ topThree[0].score }}</span>
                    </span>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
        
        <!-- Other Leaders - Minimal Style -->
        <div class="minimal-list-wrapper">
          <div class="minimal-list">
            <div class="minimal-item animate-fade-in" *ngFor="let member of leadershipMembers.slice(1); let i = index" [style.animation-delay]="(i * 0.1 + 0.2) + 's'">
              <div class="minimal-details">
                <div class="minimal-name-row-inline">
                  <h3 class="minimal-name">{{ member.name }}</h3>
                  <div class="minimal-crown" *ngIf="member.rank === 2 || member.rank === 3" [class.crown-silver]="member.rank === 2" [class.crown-bronze]="member.rank === 3">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                      <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" [attr.fill]="member.rank === 2 ? '#C0C0C0' : '#CD7F32'" [attr.stroke]="member.rank === 2 ? '#808080' : '#8B4513'" stroke-width="1.5"/>
                      <circle cx="12" cy="12" r="2" [attr.fill]="member.rank === 2 ? '#808080' : '#8B4513'"/>
                    </svg>
                  </div>
                  <div class="minimal-rank-badge minimal-rank-star" *ngIf="member.rank > 3">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="star-icon">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                    </svg>
                    <span class="star-rank-number">{{ member.rank }}</span>
                  </div>
                </div>
                <p class="minimal-role">{{ member.role }} • {{ member.title }}</p>
              </div>
              <div class="minimal-scores" *ngIf="member.score">
                <div class="minimal-score-card">
                  <span class="score-label">Published</span>
                  <span class="score-metric">
                    <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M12 19V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <path d="M7 10l5-5 5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="score-value">{{ member.score }}</span>
                  </span>
                </div>
                <div class="minimal-score-card">
                  <span class="score-label">Upvotes</span>
                  <span class="score-metric">
                    <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11a2 2 0 0 0 2-2l1-7a2 2 0 0 0-2-2h-5z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                      <path d="M7 22H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <span class="score-value">{{ member.score }}</span>
                  </span>
                </div>
                <div class="minimal-score-card">
                  <span class="score-label">Downloads</span>
                  <span class="score-metric">
                    <svg class="score-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M5 21h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    <span class="score-value">{{ member.score }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </fieldset>
      </ng-container>

      <!-- Minimal Design -->
      <ng-container *ngIf="selectedDesign === 'minimal'">
        <div class="minimal-design">
          <div class="minimal-list">
            <div class="minimal-item" *ngFor="let member of leadershipMembers">
              <div class="minimal-rank">{{ member.rank }}</div>
              <div class="minimal-avatar">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="minimal-details">
                <h3 class="minimal-name">{{ member.name }}</h3>
                <p class="minimal-role">{{ member.role }} • {{ member.title }}</p>
              </div>
              <div class="minimal-score" *ngIf="member.score">{{ member.score }}</div>
              <div class="minimal-actions">
                <a *ngIf="member.email" [href]="'mailto:' + member.email" class="minimal-link" title="Email">✉</a>
                <a *ngIf="member.linkedin" [href]="member.linkedin" target="_blank" rel="noopener noreferrer" class="minimal-link" title="LinkedIn">in</a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
        </main>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
